import { render, staticRenderFns } from "./ChatLeftPannel.vue?vue&type=template&id=3ff3742a&scoped=true&"
import script from "./ChatLeftPannel.vue?vue&type=script&lang=ts&"
export * from "./ChatLeftPannel.vue?vue&type=script&lang=ts&"
import style0 from "./ChatLeftPannel.vue?vue&type=style&index=0&id=3ff3742a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff3742a",
  null
  
)

export default component.exports